import { render } from "./MetaAdsThankYou.vue?vue&type=template&id=5c6f3c74&scoped=true"
const script = {}

import "./MetaAdsThankYou.vue?vue&type=style&index=0&id=5c6f3c74&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6f3c74"]])

export default __exports__